import { combineReducers } from 'redux'

import {always, cond, T, equals} from "ramda";
import {TYPES} from "../actions/reader";

const setAppearenceTextSize = (state = false, {type, payload}) => cond([
  [equals(TYPES.SET_APPEARENCE_TEXT_SIZE), always(payload)],
  [T, always(state)]
])(type)

const setAppearenceTextColor = (state = false, {type, payload}) => cond([
  [equals(TYPES.SET_APPEARENCE_TEXT_COLOR), always(payload)],
  [T, always(state)]
])(type)

const setAppearenceTextFont = (state = false, {type, payload}) => cond([
  [equals(TYPES.SET_APPEARENCE_TEXT_FONT), always(payload)],
  [T, always(state)]
])(type)

const setAppearenceTextFlow = (state = false, {type, payload}) => cond([
  [equals(TYPES.SET_APPEARENCE_TEXT_FLOW), always(payload)],
  [T, always(state)]
])(type)

export const appearenceReducer = combineReducers({
  size: setAppearenceTextSize,
  color: setAppearenceTextColor,
  font: setAppearenceTextFont,
  flow: setAppearenceTextFlow,
})


// WEBPACK FOOTER //
// ./src/reducers/appearenceReducer.js